import { HDateHour } from "@shared/src/datatypes/HDateHour";
import { FileTypes } from "@shared/src/enums/FileTypes";

export class SignatureDto {
    public fileType: FileTypes;
    public fileContent: any;
    public signedAt: HDateHour;
}
